// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-container[data-v-acfb685e] {\n  width: auto;\n  padding: 20px;\n  border-radius: 6px;\n  text-align: center;\n}\n.box-container .title-container[data-v-acfb685e] {\n  display: flex;\n  justify-content: space-between;\n}\n.box-container .btn-container[data-v-acfb685e] {\n  margin-top: 20px;\n}", ""]);
// Exports
module.exports = exports;
